import {
    AttributeRow,
    ClassificationRow,
    EavIndices,
    EavRow,
    EntityClassificationRow,
    EntityIdRow,
    EntityMaterialRow,
    MaterialRow,
    ValueRow,
} from "@/Models/Eav";

export const buildEavIndices = (
    ids: EntityIdRow[],
    eav: EavRow[],
    attrs: AttributeRow[],
    vals: ValueRow[],
    classifications: ClassificationRow[],
    objectsClassifications: EntityClassificationRow[],
    materials: MaterialRow[],
    objectsMaterials: EntityMaterialRow[]
): EavIndices => {
    const entityIdByExternalId = new Map<string, number>();
    for (const row of ids) {
        entityIdByExternalId.set(row.ExternalId, row.Id);
    }

    const attrsById = new Map<number, AttributeRow>();
    for (const row of attrs) {
        attrsById.set(row.Id, row);
    }

    const valuesById = new Map<number, ValueRow>();
    for (const row of vals) {
        valuesById.set(row.Id, row);
    }

    const eavByEntityId = new Map<number, EavRow[]>();
    for (const row of eav) {
        const list = eavByEntityId.get(row.EntityId);
        if (list) list.push(row);
        else eavByEntityId.set(row.EntityId, [row]);
    }

    const classificationsById = new Map<number, ClassificationRow>();
    for (const row of classifications) {
        classificationsById.set(row.Id, row);
    }

    const classificationsByEntityId = new Map<number, ClassificationRow[]>();
    for (const rel of objectsClassifications) {
        const classification = classificationsById.get(rel.ClassificationId);
        if (!classification) continue;
        const list = classificationsByEntityId.get(rel.EntityId);
        if (list) list.push(classification);
        else classificationsByEntityId.set(rel.EntityId, [classification]);
    }

    const materialsById = new Map<number, MaterialRow>();
    for (const row of materials) {
        materialsById.set(row.Id, row);
    }

    const materialsByEntityId = new Map<number, MaterialRow[]>();
    for (const rel of objectsMaterials) {
        const material = materialsById.get(rel.MaterialId);
        if (!material) continue;
        const list = materialsByEntityId.get(rel.EntityId);
        if (list) list.push(material);
        else materialsByEntityId.set(rel.EntityId, [material]);
    }

    return {
        entityIdByExternalId,
        attrsById,
        valuesById,
        eavByEntityId,
        classificationsById,
        classificationsByEntityId,
        materialsById,
        materialsByEntityId,
    };
};
